import { PlatformSlug } from 'constants/consts'

export const enabledOn = (...slugs: PlatformSlug[]): Partial<Record<PlatformSlug, true>> =>
  Object.fromEntries(slugs.map((slug) => [slug, true as const]))

export const isFeatureAvailable = <T>(config: Partial<Record<PlatformSlug, T>>, slug?: PlatformSlug) =>
  slug != null && config[slug] != null

export const getFeatureConfig = <T>(config: Partial<Record<PlatformSlug, T>>, slug?: PlatformSlug) =>
  slug != null ? config[slug] : undefined
